import * as React from 'react';
type Props = {
  className?: string;
};
export function Recent({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Recent"
      className={className}
    >
      <path
        d="M35.2748 6.86804C28.0222 -0.384559 16.2635 -0.384559 9.01086 6.86804C1.75826 14.1206 1.75826 25.8794 9.01086 33.132C16.2635 40.3846 28.0222 40.3846 35.2748 33.132M35.7143 1.42859V7.14288H30M11.4286 17.8572H32.8571L31.9449 26.1068C31.7448 27.9163 30.2157 29.2857 28.3951 29.2857H15.8906C14.07 29.2857 12.5409 27.9163 12.3408 26.1068L11.4286 17.8572ZM10.7143 15H33.5714C33.9659 15 34.2857 15.3198 34.2857 15.7143V17.1429C34.2857 17.5374 33.9659 17.8572 33.5714 17.8572H10.7143C10.3198 17.8572 9.99998 17.5374 9.99998 17.1429V15.7143C9.99998 15.3198 10.3198 15 10.7143 15ZM15.7143 15H28.5714L24.3456 9.34302C23.5714 8.2143 22.5336 7.8501 21.4735 8.37624C21.0882 8.56747 20.5585 9.24513 20.5585 9.24513L15.7143 15Z"
        stroke="currentColor"
      />
    </svg>
  );
}
